const pwa = {
  state: {
    msgToken: null,
    isShowPwa: false,
  },
  mutations: {
    SET_MSG_TOKEN: (state, msgToken) => {
      state.msgToken = msgToken;
    },
    SET_IS_SHOW_PWA: (state, isShowPwa) => {
      state.isShowPwa = isShowPwa;
    },
  },
};
export default pwa;
